import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import { BarList, Empty } from "./Primitives";

export const VehicleBreakdown = ({ vehicles }) => {
  const [openMake, setOpenMake] = useState(null);
  const [openModel, setOpenModel] = useState(null);
  if (!vehicles.length) return <Empty />;
  const top = vehicles[0].count;
  return (
    <ul className="space-y-1" data-testid="vehicle-breakdown">
      {vehicles.map((make, mi) => {
        const makeOpen = openMake === make.name;
        return (
          <li key={make.name}>
            <button
              type="button"
              onClick={() => { setOpenMake(makeOpen ? null : make.name); setOpenModel(null); }}
              className="w-full text-left rounded-md px-2 py-1.5 hover:bg-blue-50 transition-colors"
              data-testid={`vehicle-make-${mi}`}
            >
              <div className="flex items-center justify-between text-sm">
                <span className="flex items-center gap-1 font-semibold text-gray-900">
                  {makeOpen ? <ChevronDown className="w-4 h-4 text-gray-400" /> : <ChevronRight className="w-4 h-4 text-gray-400" />}
                  {make.name}
                </span>
                <span className="tabular-nums text-gray-600">{make.count} <span className="text-gray-400">· {make.share}%</span></span>
              </div>
              <div className="h-2 bg-gray-100 rounded mt-1 ml-5 overflow-hidden">
                <div className="h-full bg-blue-600 rounded" style={{ width: `${(make.count / top) * 100}%` }} />
              </div>
            </button>
            {makeOpen && (
              <ul className="ml-6 mt-1 mb-2 space-y-1 border-l-2 border-blue-100 pl-3">
                {make.models.map((model, idx) => {
                  const modelOpen = openModel === model.name;
                  return (
                    <li key={model.name}>
                      <button
                        type="button"
                        onClick={() => setOpenModel(modelOpen ? null : model.name)}
                        className="w-full text-left rounded-md px-2 py-1 hover:bg-blue-50"
                        data-testid={`vehicle-model-${idx}`}
                      >
                        <div className="flex items-center justify-between text-sm">
                          <span className="flex items-center gap-1 text-gray-800">
                            {modelOpen ? <ChevronDown className="w-3.5 h-3.5 text-gray-400" /> : <ChevronRight className="w-3.5 h-3.5 text-gray-400" />}
                            {model.name}
                          </span>
                          <span className="tabular-nums text-gray-600">{model.count} <span className="text-gray-400">· {model.share}%</span></span>
                        </div>
                      </button>
                      {modelOpen && (
                        <div className="ml-6 my-1 pl-3 border-l-2 border-gray-100" data-testid="vehicle-years">
                          <BarList items={model.years} />
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
};
